
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","fill":"#fff"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.785 1.723H9.527a.527.527 0 000 1.054h6.258c.64 0 1.16.52 1.16 1.16v3.375c0 .64-.52 1.16-1.16 1.16h-.506l.318-.317a.527.527 0 00-.746-.746l-1.591 1.59 1.59 1.592a.527.527 0 10.747-.746l-.318-.318h.506A2.217 2.217 0 0018 7.312V3.938a2.217 2.217 0 00-2.215-2.215zM6.912 14.159a.527.527 0 000 .745l.318.318H2.215c-.64 0-1.16-.52-1.16-1.16v-3.374c0-.64.52-1.16 1.16-1.16h1.758a.527.527 0 000-1.055H2.215A2.217 2.217 0 000 10.687v3.375c0 1.222.994 2.215 2.215 2.215H7.23l-.318.318a.527.527 0 10.746.746l1.59-1.591-1.59-1.591a.527.527 0 00-.746 0zM4.702 3.34a.379.379 0 01-.399 0L1.132 1.402v2.574c0 .55.446.996.996.996h4.757c.55 0 .997-.446.997-.996V1.403l-3.18 1.936z"}}),_c('path',{attrs:{"d":"M6.908 0H2.105a1 1 0 00-.973.787L4.51 2.842 7.88.787A1 1 0 006.909 0zM13.695 16.366a.379.379 0 01-.398 0l-3.172-1.936v2.574c0 .55.446.996.996.996h4.758c.55 0 .996-.446.996-.996V14.43l-3.18 1.936z"}}),_c('path',{attrs:{"d":"M15.902 13.027h-4.803a1 1 0 00-.974.787l3.379 2.056 3.371-2.056a1 1 0 00-.973-.787zM9.195 9.853a.379.379 0 01-.398 0L5.625 7.916v2.574c0 .55.446.996.996.996h4.758c.55 0 .996-.446.996-.996V7.916l-3.18 1.937z"}}),_c('path',{attrs:{"d":"M11.402 6.514H6.598a1 1 0 00-.973.786l3.379 2.056L12.375 7.3a1 1 0 00-.973-.786z"}})])
          )
        }
      }
    